<template>
  <div class="order_form_point">
    <point-select :config="{ must: true }" labelText="广告类型" v-model="elType" :pList="adTypes">
      <div slot="empty" class="my-sel-empty__data">暂未开通，请联系管理员</div>
    </point-select>
    <el-form size="mini" :model="order">
      <el-form-item class="must" label="投放城市">
        <MultCityAsync ref="cityChoose" @change="getAddressCodes"></MultCityAsync>
      </el-form-item>
      <el-form-item class="must" label="投放时间">
        <div class="date-item"></div>
        <el-date-picker
          class="input-date"
          type="date"
          value-format="yyyy-MM-dd"
          :clearable="false"
          placeholder="选择开始时间"
          prefix-icon="el-icon-arrow-down"
          style="margin-right: 10px;"
          :picker-options="startPickerOptions"
          v-model="order.startDate"
          @change="startDateChange">
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          class="input-date"
          type="date"
          value-format="yyyy-MM-dd"
          :clearable="false"
          placeholder="选择结束时间"
          prefix-icon="el-icon-arrow-down"
          :picker-options="endPickerOptions"
          v-model="order.endDate"
          @change="endDateChange">
        </el-date-picker>
        <i class="iconfont icon-biaodan-shijian"></i>
      </el-form-item>
      <el-form-item class="must" label="投放时段">
        <el-popover placement="bottom" trigger="click" popper-class="time-slot" @show="showTime = !showTime" @hide="showTime = !showTime">
          <div slot="reference" class="time-area">
            <span class="fl els">{{ timeStr }}</span>
            <i class="fr el-icon-arrow-down" :class="{ 'up': showTime }"></i>
          </div>
          <SearchTimeRange ref="timeRangeRef" :isInit="true" @submit="confirmTimeSegment"></SearchTimeRange>
        </el-popover>
      </el-form-item>
      <el-form-item class="must dmp" label="单次曝光">
        <el-select placeholder="请选择" popper-class="form_pop" v-model="order.contentTime">
          <el-option v-for="t in exposeList" :key="t.dictItemCode" :value="t.dictItemName" :label="t.dictItemName+'秒'"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="must dmp" label="CPR+标签">
        <CprPlusLabel v-model="order.personsLabels"></CprPlusLabel>
      </el-form-item>
      <el-form-item class="must dmp" label="投放模式">
        <el-select placeholder="选择投放模式" popper-class="form_pop" v-model="order.dmpInterruptType">
          <el-option v-for="t in cprPlusModes" :key="t.value" :value="t.value" :label="t.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="number_input must" label="合同单价">
        <el-input-number
          size="mini"
          placeholder="请输入"
          :controls="false"
          :min="0.01"
          :max="9999"
          :precision="2"
          :step="0.1"
          v-model="order.unitPrice">
        </el-input-number>
        <i class="unit_append">元/千人次</i>
      </el-form-item>
      <el-form-item class="number_input must" label="流量总限">
        <el-input-number
          size="mini"
          placeholder="请输入"
          :controls="false"
          :min="0.01"
          :max="9999"
          :precision="2"
          :step="0.1"
          v-model="order.targetFlowOrbudgetAmount">
        </el-input-number>
        <i class="unit_append">千人次</i>
      </el-form-item>
      <el-form-item class="number_input" label="流量日限">
        <el-input-number
          size="mini"
          placeholder="请输入"
          :controls="false"
          :min="0.01"
          :max="9999"
          :precision="2"
          :step="0.1"
          v-model="order.dailyFlowLimit">
        </el-input-number>
        <i class="unit_append">千人次</i>
      </el-form-item>
      <PointLimit :limitFlow.sync="order.pointLimitFlow" :limitPlayCount.sync="order.pointLimitPlayCount"></PointLimit>
      <el-form-item class="must custom" label="合同编码">
        <el-input placeholder="请输入正确的合同编码" :maxlength="30" v-model="order.contractNo" @blur="contractHandle" @keyup.enter.native="contractHandle">
          <i slot="suffix" class="iconfont icon-biaodan-tianxie"></i>
        </el-input>
      </el-form-item>
      <!-- <el-form-item class="must" label="展现位置">
        <el-select placeholder="选择展现位置" popper-class="form_pop" v-model="order.displayRegion">
          <el-option v-for="reg in displayRegions" :key="reg.value" :label="reg.label" :value="reg.value"></el-option>
        </el-select>
      </el-form-item> -->
<!--      &lt;!&ndash;新禁播标签&ndash;&gt;-->
<!--      <el-form-item  label="禁播标签">-->
<!--&lt;!&ndash;        <el-select placeholder="选择禁播标签" popper-class="form_pop" v-model="order.noPlayingLabels" multiple>&ndash;&gt;-->
<!--&lt;!&ndash;          <el-option v-for="item in noPlayingLabels" :key="item.dictItemCode" :label="item.dictItemName" :value="item.dictItemName" ></el-option>&ndash;&gt;-->
<!--&lt;!&ndash;        </el-select>&ndash;&gt;-->
<!--        <NoPlayingLabelSelector  v-model="order.noPlayingLabels"></NoPlayingLabelSelector>-->
<!--      </el-form-item>-->
    </el-form>

    <div class="btm">
      <div class="btn search" @click="searchAction">筛选点位</div>
      <div class="btn" @click="reset">重置条件</div>
    </div>
  </div>
</template>

<script>
import PointSelect from '@/views/PutOrder/components/OrderForm/Select'
import CprPlusLabel from './CprPlusLabelSelect'
import SearchTimeRange from '@/components/SearchTimeRange'
import PointLimit from './CprPlusPointLimit'
import NoPlayingLabelSelector from "@/components/NoPlayingLabelSelector";

const dayMs = 24 * 3600000
const dateNow = new Date()

export default {
  name: 'OrderFormPoint',
  components: {NoPlayingLabelSelector, PointSelect, CprPlusLabel, SearchTimeRange, PointLimit },
  data() {
    let vm = this
    return {
      elType: [],
      order: {
        orderLabels: ['L3','M1'],
        orderType: 6005, // CPR+订单类型值固定
        advertType: '',
        startDate: new Date(+dateNow + 2 * dayMs).format().slice(0, 10),
        endDate: new Date(+dateNow + 8 * dayMs).format().slice(0, 10),
        contentTime: '',
        personsLabels: [], // CPR+标签
        dmpInterruptType: 2, // 投放模式 1:标准 2:高级
        unitPrice: undefined,
        targetFlowOrbudgetAmount: undefined,
        dailyFlowLimit: undefined,
        pointLimitFlow: undefined,
        pointLimitPlayCount: undefined,
        contractNo: '',
        displayRegion: 1,
        noPlayingLabels:[],
      },
      startPickerOptions: {
        disabledDate (t) {
          const dt = new Date(t)
          return dt - dateNow < -dayMs || dt - dateNow > 89 * dayMs
        }
      },
      endPickerOptions: {
        disabledDate (d) {
          const dt = new Date(d)
          const theStart = new Date(vm.order.startDate)
          return dt - theStart - 89 * dayMs > 0 || dt - theStart < -dayMs || dt - dateNow > 89 * dayMs
        }
      },
      timeStr: '',
      searchTimeRange: [], // 投放时段
      showTime: false
    }
  },
  computed: {
    adTypes() {
      // CPR+广告 => CPR收费(2)、定制商业(3)、普通公益(4)、定制公益(5)
      const origin = this.$store.state.common.advertTypes || []
      const auth = origin.filter(e => [2, 3, 4, 5].indexOf(e.value) > -1)
      return auth.map(e => {
        e.code = e.value
        e.name = e.label
        return e
      })
    },
    exposeList() {
      return this.$store.state.bmap.labelTimeSlotList || []
    },
    cprPlusModes() {
      return this.$store.state.order.cprPlusModeList
    },
    noPlayingLabels(){
      return this.$store.state.common['NEW_NO_PLAY_LABLE']
    }
  },
  watch: {
    exposeList(v) {
      if (v && v.length) {
        this.initExpose()
      }
    },
    elType(v) {
      this.order.advertType = v ? v[0] : undefined
    }
  },
  created() {
    this.initExpose()
  },
  methods: {
    getAddressCodes(data, initData) { // 改成只传所有选中的最顶层节点
      if (initData) {
        this.order.addressCodes = initData
        return
      }
      let addressCodesParam = this.rmCheckItemChilds(data)
      this.order.addressCodes = addressCodesParam.map(el => el.split('^^').join('.')).map(el => el.indexOf('.') < 0 ? el + '.' : el)
    },
    rmCheckItemChilds(res) {
      let data = []
      let final = res.map(el => el.ids).sort()
      final.forEach(item => {
        data.forEach(el => {
          if ((item + '').indexOf(el) > -1) item = null
        })
        if (item) data.push(item + '')
      })
      return data
    },
    startDateChange(data) {
      if (this.order.endDate && new Date(data).getTime() > new Date(this.order.endDate).getTime()) {
        this.messageTip('结束时间须不能小于开始时间')
        this.order.endDate = ''
      }
    },
    endDateChange(data) {
      if (this.order.startDate && new Date(data).getTime() < new Date(this.order.startDate).getTime()) {
        this.messageTip('结束时间须不能小于开始时间')
        this.order.endDate = ''
      }
    },
    confirmTimeSegment({ data, type }) {
      const list = data || []
      this.timeStr = list.map(e => e.frequencyName).join('、')
      this.searchTimeRange = list
      this.order.timeSegmentType = type
    },
    contractHandle() {
      this.order.contractNo = (this.order.contractNo || '').trim()
    },
    // 合同编码仅能输入字母、数字
    // verifyContract(v) {
    //   this.order.contractNo = v.replace(/[^A-Za-z\d]/g, '')
    // },
    searchAction() {
      if (!this.testInput()) return

      const opt = JSON.parse(JSON.stringify(this.order))
      opt.searchTimeRange = this.searchTimeRange
      this.$emit('submit', opt)
      this.$store.commit('setStoreData', { key: 'conditionSearchCitys', value: this.$refs.cityChoose.$refs.tree.getCheckedNodes(false, true) })
      this.$store.commit('order/setForm', this.order)
    },
    testInput() {
      const {
        advertType,
        addressCodes: regions,
        startDate,
        endDate,
        contentTime,
        personsLabels,
        dmpInterruptType,
        unitPrice,
        targetFlowOrbudgetAmount: limitAll,
        dailyFlowLimit: dailyLimit,
        contractNo
      } = this.order

      if (!advertType) {
        return this.messageTip('请选择广告类型', 2)
      }
      if (!regions || regions.length === 0) {
        if (this.$refs.cityChoose && this.$refs.cityChoose.isWhole) {
          // this.order.addressCodes = [1] // 全国传空数组
        } else {
          return this.messageTip('请选择投放城市', 2)
        }
      }
      if (!startDate) return this.messageTip('请选择投放开始日期', 2)
      if (!endDate) return this.messageTip('请选择投放结束日期', 2)
      if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
        return this.messageTip('结束日期须大于等于开始日期', 2)
      }
      if (new Date(endDate).getTime() - new Date(startDate).getTime() > 30 * 24 * 60 * 60 * 1000) {
        return this.messageTip('时间范围须小于等于31天', 2)
      }
      const adDuration = (contentTime || '').trim()
      if (!adDuration) return this.messageTip('请选择单次曝光', 2)

      if (!personsLabels || !personsLabels.length) return this.messageTip('请选择CPR+标签', 2)
      if (dmpInterruptType === undefined) return this.messageTip('请选择投放模式', 2)

      if (!unitPrice) return this.messageTip('请输入合同单价', 2)
      if (unitPrice <= 0) return this.messageTip('合同单价须大于0', 2)
      if (limitAll === undefined) return this.messageTip('请填写流量总限', 2)
      if (dailyLimit <= 0) return this.messageTip('流量日限须大于0', 2)

      const contract = (contractNo || '').trim()
      if (!contract) return this.messageTip('请输入合同编码', 2)
      this.order.contractNo = contract // 合同编码将前后可能误输入的空格去除后重新赋值

      return true
    },
    reset() {
      this.initExpose()
      if (this.$refs.cityChoose) this.$refs.cityChoose.initHangZhou()
      this.order.startDate = new Date(+dateNow + 2 * dayMs).format().slice(0, 10)
      this.order.endDate = new Date(+dateNow + 8 * dayMs).format().slice(0, 10)
      if (this.$refs.timeRangeRef) {
        this.$refs.timeRangeRef.init()
      }
      this.order.unitPrice = undefined
      this.order.contractNo = ''
      this.order.displayRegion = 1
      this.order.noPlayingLabels = []
      this.order.targetFlowOrbudgetAmount = undefined
    },
    initExpose() {
      const defExp = this.exposeList.filter(e => e.default)[0] // 默认单次曝光
      if (defExp) {
        this.order.contentTime = defExp.dictItemName
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.order_form_point
  padding: 20px
  height: calc(100% - 66px)
  overflow: auto
  .unit_append
    color: #909399
    width: 65px
    position: absolute
    right: 10px
    top: 50%
    transform: translateY(-50%)
    text-align: right
  ::v-deep .el-form
    .el-form-item
      margin-bottom: 20px
      box-shadow: 0 0 0 1px #e9e9e9 inset
      border-radius: 4px
      padding: 5px 0 5px 17px
      .el-form-item__label
        color: #282729
        font-weight: 600
        border-right: 1px solid #e9e9e9
        padding: 0 10px 0 0
        margin-top: 5px
        line-height: 20px
      &.dmp
        position: relative
        padding-left: 0
        .el-form-item__label
          position: absolute
          left: 20px
          top: 50%
          margin-top: -10px
          z-index: 1
          padding-right: 7px
        .el-form-item__content .el-select
          width: 100%
          .el-input
            width: auto
          .el-input__inner
            padding-left: 98px
          .el-input__suffix
            right: 8px
      &.custom
        .el-input
          width: 220px
          input
            padding-right: 30px
      &.number_input
        .el-input-number
          width: 220px
          input
            width: 110px
            text-align: left
    .el-form-item__content
      .el-select
        .el-select__tags
          padding-left: 10px
        .el-input
          width: 215px
    .label_box
      padding-left: 98px
    .icon-biaodan-shijian
      color: #c0c4cc

    .el-select, .el-input
      &.input-date
        width: 92px
        padding-left: 0
        margin-right: 3px
        > input
          padding-left: 10px
      input
        border: none
        padding-right: 0
        &:focus
          border-bottom: none !important
      .el-input__prefix
        display: none

    .el-select .el-tag
      margin: 2px 2px 2px 0
    .el-input--mini
      font-size: 14px

  ::v-deep .cmn_labels
    .label-slt
      margin-bottom: 20px

.time-area
  float: right
  width: 220px
  height: 28px
  line-height: 28px
  cursor: pointer
  span
    width: 192px
    display: inline-block
  i
    margin-left: 4px
    margin-right: 10px
    margin-top: 9px
    color: #C0C4CC
    &.up
      transform: rotate(180deg)

.btm
  border-top: 1px solid #E9E9E9
  padding: 0  20px
  position: absolute
  bottom: 0
  width: 100%
  margin: 0 -20px
  text-align: center
  .btn
    width: 150px
    line-height: 40px
    font-weight: 400
    text-align: center
    color: #282729
    cursor: pointer
    margin: 15px 0
    border: 1px solid #D4D4D4
    border-radius: 4px
    display: inline-block
    &.search
      background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%)
      color: #fff
      margin-right: 20px
      border: 0

</style>
